import { Route } from 'react-router-dom';
import CardCallback from './components/CardCallback';
import userIsAuthenticated from '../routes/guards/UserIsAuthenticated';

// @ts-ignore
const ConfirmCard = userIsAuthenticated(CardCallback);

export default [<Route key="confirm-card" path="/confirm-card/:id" component={ConfirmCard} />];
